// These constants are injected via webpack environment variables.
// You can add more variables in webpack.common.js or in profile specific webpack.<dev|prod>.js files.
// If you change the values in the webpack config files, you need to re run webpack to update the application
import { VERSION, SERVER_API_URL, BUILD_TIMESTAMP, DEBUG_INFO_ENABLED, FEEDBACK_ENABLED, MAX_PAGE_SIZE, FILE_UPLOAD_SUPPORTED_TYPES } from './environment.constants';
export { VERSION, SERVER_API_URL, BUILD_TIMESTAMP, DEBUG_INFO_ENABLED, FEEDBACK_ENABLED, MAX_PAGE_SIZE, FILE_UPLOAD_SUPPORTED_TYPES };


export const enum ViewEnum {
    STUDY_EDITOR = 'study-editor',
    STUDY_MANAGER = 'study-manager' ,
    GERMPLASM_LIST_MANAGER = 'germplasm-list',
    GERMPLASM_MANAGER = 'germplasm-manager',
    PROGRAM_SETTING_MANAGER = 'program-settings-manager',
    CROP_SETTING_MANAGER = 'crop-settings-manager',
    ABOUT = 'about',
    SINGLE_SITE_ANALYSIS = 'single-site-analysis',
    MULTI_SITE_ANALYSIS = 'multi-site-analysis',
    SAMPLE_MANAGER = 'sample-manager',
    FIELD_MANAGER = 'field-management',
    SITE_ADMIN = 'site-admin',
    PROGRAMS = 'programs',
    CREATE_STUDY = 'create-study',
    INVENTORY_MANAGER = 'inventory-manager',
    MULTI_TRAIT_QUERY = 'multi-trait-query',
    HEAD_TO_HEAD_QUERY = 'head-to-head-query',
    BRAPI_SYNC = 'brapi-sync',
    ONTOLOGY_MANAGER = 'ontology-manager'
}

export const GERMPLASM_BROWSER_DEFAULT_URL = '/ibpworkbench/maingpsb/germplasm-';
export const GERMPLASM_LIST_MANAGER_URL = '/ibpworkbench/main/app/#/germplasm-list/list/';
export const BREEDING_METHODS_BROWSER_DEFAULT_URL = '/ibpworkbench/content/ProgramMethods';
export const GERMPLASM_DETAILS_URL = '/ibpworkbench/controller/jhipster#/germplasm-details/';
export const GERMPLASM_SEARCH_SELECTOR = '/ibpworkbench/controller/jhipster#/germplasm-selector/';
export const INVENTORY_DETAILS_URL = '/ibpworkbench/main/app/#/inventory-details/';
export const GRAPHICAL_QUERIES_URL = '/ibpworkbench/controller/graphical-queries/';
export const USER_PROGRAM_INFO = '/ibpworkbench/context/program';
export const GERMPLASM_LABEL_PRINTING_TYPE = 'Germplasm';
export const GERMPLASM_LIST_LABEL_PRINTING_TYPE = 'Germplasm List';
export const FILE_MANAGER_URL = '/ibpworkbench/controller/jhipster#/file-manager/';

export const TINY_BLANK_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
export const EMPTY_PAGE_URL = 'about:blank';
export const COP_ASYNC_PROGRESS_REFRESH_MILLIS = 5000;

// HELP
export const HELP_BASE_URL = '/bmsapi/help/getUrl/';
export const HELP_MANAGE_SAMPLES = 'MANAGE_SAMPLES';
export const HELP_MANAGE_GERMPLASM = 'MANAGE_GERMPLASM';
export const HELP_MANAGE_GERMPLASM_IMPORT = 'MANAGE_GERMPLASM_IMPORT';
export const HELP_MANAGE_GERMPLASM_IMPORT_TEMPLATE = 'MANAGE_GERMPLASM_IMPORT_TEMPLATE';
export const HELP_MANAGE_GERMPLASM_IMPORT_UPDATES = 'MANAGE_GERMPLASM_IMPORT_UPDATES';
export const HELP_MANAGE_GERMPLASM_IMPORT_UPDATES_TEMPLATE = 'MANAGE_GERMPLASM_IMPORT_UPDATES_TEMPLATE';
export const HELP_NAVIGATION_BAR_ABOUT_BMS = 'NAVIGATION_BAR_ABOUT_BMS';
export const HELP_NAVIGATION_ASK_FOR_SUPPORT = 'NAVIGATION_BAR_ASK_FOR_SUPPORT';
export const HELP_DASHBOARD = 'DASHBOARD';
export const HELP_GERMPLASM_LIST = 'GERMPLASM_LIST';
export const HELP_GERMPLASM_LIST_IMPORT = 'GERMPLASM_LIST_IMPORT';
export const HELP_GERMPLASM_LIST_IMPORT_UPDATE = 'GERMPLASM_LIST_IMPORT_UPDATE';
export const HELP_GERMPLASM_LIST_COP_BETA = 'GERMPLASM_LIST_COP_BETA';
export const HELP_LABEL_PRINTING_GERMPLASM_MANAGER = 'LABEL_PRINTING_GERMPLASM_MANAGER';
export const HELP_LABEL_PRINTING_GERMPLASM_LIST_MANAGER = 'LABEL_PRINTING_GERMPLASM_LIST_MANAGER';
export const HELP_LABEL_PRINTING_STUDY_MANAGER = 'LABEL_PRINTING_STUDY_MANAGER';
export const HELP_LABEL_PRINTING_INVENTORY_MANAGER = 'LABEL_PRINTING_INVENTORY_MANAGER';
export const HELP_LABEL_PRINTING_STUDY_ENTRIES_MANAGER = 'LABEL_PRINTING_STUDY_ENTRIES_MANAGER';
export const HELP_LABEL_PRINTING_SAMPLE_MANAGER = 'LABEL_PRINTING_SAMPLE_MANAGER';
export const HELP_GRAPHICAL_QUERIES = 'GRAPHICAL_QUERIES';
export const HELP_MANAGE_PROGRAM_SETTINGS = 'MANAGE_PROGRAM_SETTINGS';
export const HELP_MANAGE_ONTOLOGIES = 'MANAGE_ONTOLOGIES';
export const HELP_MANAGE_ONTOLOGIES_FORMULAS = 'MANAGE_ONTOLOGIES_FORMULAS';
export const HELP_MANAGE_CROP_SETTINGS = 'MANAGE_CROP_SETTINGS';
export const HELP_NAME_RULES_FOR_NEW_GERMPLASM = 'NAME_RULES_FOR_NEW_GERMPLASM';
export const HELP_MANAGE_STUDIES = 'MANAGE_STUDIES';
export const HELP_DESIGN_CROSSES = 'DESIGN_CROSSES';
export const HELP_SINGLE_SITE_ANALYSIS = 'SINGLE_SITE_ANALYSIS';
export const HELP_MULTI_SITE_ANALYSIS = 'MULTI_SITE_ANALYSIS';
export const HELP_FIELDMAP_MANAGER = 'FIELDMAP_MANAGER';
export const HELP_MAKE_FIELD_MAP = 'MAKE_FIELD_MAPS';
export const HELP_MANAGE_STUDIES_TREATMENT_FACTORS = 'MANAGE_STUDIES_TREATMENT_FACTORS';
export const HELP_MANAGE_STUDIES_SETTINGS = 'MANAGE_STUDIES_SETTINGS';
export const HELP_MANAGE_STUDIES_ENVIRONMENT = 'MANAGE_STUDIES_ENVIRONMENT';
export const HELP_MANAGE_STUDIES_EXPERIMENTAL_DESIGN = 'MANAGE_STUDIES_EXPERIMENTAL_DESIGN';
export const HELP_MANAGE_STUDIES_GERMPLASM = 'MANAGE_STUDIES_GERMPLASM';
export const HELP_MANAGE_STUDIES_FIELDMAP_GEOREFERENCE = 'MANAGE_STUDIES_FIELDMAP_GEOREFERENCE';
export const HELP_MANAGE_STUDIES_SUB_OBSERVATIONS = 'MANAGE_STUDIES_SUB_OBSERVATIONS';
export const HELP_MANAGE_INVENTORY = 'MANAGE_INVENTORY';
export const HELP_MULTI_TRAIT_QUERY = 'TRAIT_DONOR';
export const HELP_HEAD_TO_HEAD = 'HEAD_TO_HEAD';

export const ADD_NEW_PROGRAM = 'PROGRAM_CREATION';

// CVTERM IDS
export const TRIAL_INSTANCE_CVTERM_ID = 8170;
export const EXPT_DESIGN_CVTERM_ID = 8135;
export const LOCATION_ID_CVTERM_ID = 8190;
export const PLOT_NO_CVTERM_ID = 8200;
export const ENTRY_NO_CVTERM_ID = 8230;
export const ROW_CVTERM_ID = 8581;
export const COL_CVTERM_ID = 8582;
export const FIELDMAP_COLUMN_CVTERM_ID = 8400;
export const FIELDMAP_RANGE_CVTERM_ID = 8410;

export const COOPERATOR_CVTERM_ID = 8373;

export const PI_NAME_CVTERM_ID = 8100;

export const GENOTYPING_SERVER = 'gigwa';

export const HELP_SITE_ADMINISTRATION = 'SITE_ADMINISTRATION';

export const MAX_ATTRIBUTE_DISPLAY_SIZE = 100;
export const MAX_NAME_DISPLAY_SIZE = 100;
export const STORAGE_LOCATION_TYPE_ID = 1500;
export const ALLOWED_ADDITIONAL_SYSTEM_VARIABLES = [ROW_CVTERM_ID, COL_CVTERM_ID, FIELDMAP_RANGE_CVTERM_ID, FIELDMAP_COLUMN_CVTERM_ID];
